import { CalendarPlus } from "lucide-react";
import { useLanding } from "@/context/LandingContext";
import { calendarLinks } from "@/lib/calendar";
import { SEMINAR } from "@/seminars";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path fill="#4285F4" d="M21.6 12.23c0-.68-.06-1.33-.17-1.96H12v3.71h5.38a4.6 4.6 0 0 1-2 3.02v2.5h3.24c1.9-1.75 2.98-4.32 2.98-7.27z" />
    <path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.42l-3.24-2.5c-.9.6-2.04.95-3.38.95-2.6 0-4.8-1.75-5.58-4.11H3.07v2.58A10 10 0 0 0 12 22z" />
    <path fill="#FBBC05" d="M6.42 13.92A6 6 0 0 1 6.1 12c0-.67.12-1.31.32-1.92V7.5H3.07A10 10 0 0 0 2 12c0 1.61.39 3.14 1.07 4.5l3.35-2.58z" />
    <path fill="#EA4335" d="M12 5.97c1.47 0 2.78.5 3.82 1.5l2.86-2.87A9.98 9.98 0 0 0 12 2 10 10 0 0 0 3.07 7.5l3.35 2.58C7.2 7.72 9.4 5.97 12 5.97z" />
  </svg>
);

const AppleIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M16.37 12.6c.03 2.86 2.5 3.81 2.53 3.82-.02.07-.4 1.36-1.3 2.7-.79 1.15-1.6 2.3-2.89 2.32-1.26.02-1.67-.75-3.11-.75s-1.9.73-3.09.77c-1.24.05-2.19-1.24-2.98-2.39C3.9 16.72 2.66 12.44 4.32 9.54a4.63 4.63 0 0 1 3.9-2.37c1.22-.02 2.37.82 3.11.82.75 0 2.14-1.01 3.6-.86.62.03 2.34.25 3.45 1.88-.09.06-2.06 1.2-2.01 3.59zM13.99 5.6c.66-.8 1.1-1.9.98-3-.95.04-2.1.63-2.78 1.43-.61.7-1.14 1.83-1 2.91 1.06.08 2.14-.54 2.8-1.34z" />
  </svg>
);

const OutlookIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path fill="#0F6CBD" d="M2 6.5 12.5 4v16L2 17.5z" />
    <path fill="#28A8EA" d="M12.5 7h9.5v10.5h-9.5z" opacity=".9" />
    <ellipse cx="7.3" cy="12" rx="2.6" ry="3.4" fill="#fff" />
    <ellipse cx="7.3" cy="12" rx="1.2" ry="1.9" fill="#0F6CBD" />
  </svg>
);

export function AddToCalendar({ registrationId, calendarToken }) {
  const { t, lang, selectedEvent } = useLanding();
  const c = t.register.calendar;
  const links = calendarLinks({
    registrationId,
    calendarToken,
    iso: selectedEvent.iso,
    title: c.title,
    details: `${c.details}\n${window.location.origin}`,
    location: t.register.venue,
  });
  const items = [
    { key: "google", href: links.google, label: c.google, Icon: GoogleIcon, external: true },
    { key: "apple", href: links.ics, label: c.apple, Icon: AppleIcon, download: lang === "zh" ? `${SEMINAR.id}-webinar-zh.ics` : `${SEMINAR.id}-webinar.ics` },
    { key: "outlook", href: links.outlook, label: c.outlook, Icon: OutlookIcon, external: true },
  ];
  return (
    <div className="add-to-calendar" data-testid="add-to-calendar">
      <p className="add-to-calendar-title"><CalendarPlus size={15} /> {c.heading}</p>
      <div className="add-to-calendar-row">
        {items.map(({ key, href, label, Icon, external, download }) => (
          <a
            key={key}
            href={href}
            className="calendar-btn"
            target={external ? "_blank" : undefined}
            rel={external ? "noopener noreferrer" : undefined}
            download={download}
            data-testid={`calendar-${key}-btn`}
          >
            <Icon /> {label}
          </a>
        ))}
      </div>
    </div>
  );
}
